/* This example requires Tailwind CSS v2.0+ */
import { ChevronRightIcon } from '@heroicons/react/solid'
import clsx from 'clsx'
import { NavLink } from 'react-router-dom'

interface BreadCrumbsProps {
  breadCrumbPages: {
    name: string
    href: string
  }[]
}

const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ breadCrumbPages }) => {
  return (
    <nav className="mb-5 flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-4">
        {breadCrumbPages.map((page, index) => (
          <li key={page.name}>
            <div className="flex items-center" key={page.name}>
              {index === 0 ? null : (
                <ChevronRightIcon className="mr-4 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
              )}
              <NavLink
                to={page.href}
                end
                className={({ isActive }) =>
                  clsx({
                    'text-sm  text-gray-500': true,
                    'font-medium hover:text-gray-700': !isActive,
                    'font-normal': isActive,
                  })
                }
              >
                {page.name}
              </NavLink>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default BreadCrumbs
